import { Controller } from "stimulus"

export default class Thumbnail extends Controller {
  initialize() {
    this.onImageError = this.fallbackThumbnail.bind(this)
    this.onMouseEnter = this.showAnimated.bind(this)
    this.onMouseLeave = this.showStatic.bind(this)
  }

  connect() {
    this.image = this.imageTarget
    this.staticSrc = this.image.src
    this.animatedSrc = this.element.dataset.animatedSrc
    this.fallbackSrc = this.element.dataset.fallbackSrc || "https://s3-us-west-2.amazonaws.com/supercast-static/default_channel_artwork.jpg"
    this.fallbackTriggered = false

    this.image.addEventListener("error", this.onImageError)

    if (this.animatedSrc) {
      this.element.addEventListener("mouseenter", this.onMouseEnter)
      this.element.addEventListener("mouseleave", this.onMouseLeave)
    }
  }

  disconnect() {
    this.image?.removeEventListener("error", this.onImageError)
    this.element.removeEventListener("mouseenter", this.onMouseEnter)
    this.element.removeEventListener("mouseleave", this.onMouseLeave)
  }

  fallbackThumbnail() {
    if (this.fallbackTriggered) return

    this.fallbackTriggered = true
    this.element.dataset.fallbackTriggered = "true"
    this.image.src = this.fallbackSrc
  }

  showAnimated() {
    if (!this.fallbackTriggered) this.image.src = this.animatedSrc
  }

  showStatic() {
    if (!this.fallbackTriggered) this.image.src = this.staticSrc
  }
}

Thumbnail.targets = ["image"]